export default __webpack_public_path__ + "static/media/ldo_ADJ_nEN_nCff.5f4ab5ce.svg";